import Vue from "vue";
import Vuex from "vuex";
import { modules } from "@/store/modules";
import { state } from "./state";
import { mutations } from "./mutations";
import { actions } from "./actions";
import { getters } from "./getters";
export { modules, state, actions, getters, mutations };

Vue.use(Vuex);

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== "production",
  modules,
  state,
  getters,
  mutations,
  actions,
});
